export default {
  home: {
    title: 'データ登録',
    deadline: '登録締切：',
    form: {
      success: 'フォームを送信しました！',
      folderContact: {
        title: 'このファイルの担当者',
        subtitle: '情報は販促物には表示されません',
        firstname: '名',
        lastname: '姓',
        phone: '連絡先電話番号',
        mobile: '連絡先携帯電話',
        email: '連絡先メール／ログインID',
        password: 'パスワード',
      },
      qrcode: {
        title: '会社情報QRコード',
        text: 'オンラインで会社プロフィールを見る',
        download: 'QRコードをダウンロード',
      },
      companyInfo: {
        title: '会社情報',
        company: '会社名',
        commercialName: '商号',
        commercialNameInfo: '各種販促物に表示される名称',
        address: '住所',
        zipcode: '郵便番号',
        city: '市区町村',
        country: '国',
        phone: '代表電話番号',
        email: '会社代表メールアドレス',
        website: 'ウェブサイト',
        companyType: '会社の種類',
        siret: 'ABN',
        domainSize: '畑の面積',
        domainSizeDetail: '（0〜100,000ヘクタール）',
        yearProduct: '年間生産量',
        yearProductDetail: '（0〜10,000,000本）',
        exportPercent: '輸出比率',
        exportMarket: '輸出市場（複数選択可）',
        exportMarketWish: '輸出拡大の希望市場（複数選択可）',
        compagnyPresentation: '会社紹介（英語、500文字以内）',
        webLogo: 'ウェブ用会社ロゴ',
        webLogoFormat: '（jpg、png、最大5MB）',
        HdLogo: '高解像度ロゴ',
        HdLogoFormat: '（pdf、eps、ai：最大10MB）',
        HdLogoFormatEvent:
          'このロゴは、ブースのコンセプトに応じて印刷に使用される場合があります（pdf、eps、ai：最大10MB）',
      },
      galery: {
        title: 'ギャラリー',
        photos: '会社の写真',
        photosDetail: '（5点、jpg、png、最大5MB）',
        videoLink: '会社紹介のYouTube動画リンク',
      },
      contact: {
        title: '連絡先',
        titleDetail: '（販促物に表示される情報）',
        firstname: '名',
        lastname: '姓',
        mobile: '携帯電話',
        phone: '電話番号',
        email: 'メールアドレス',
      },
      products: {
        title: '選択した製品',
        info: '最大30点まで紹介できます',
        addProduct: '製品を追加',
        product: '製品',
        edit: '編集',
        checkbox:
          '収集された個人情報は、イベント主催者によって処理されます。これらの情報は、イベントの運営、または資料やサービスの送付に必要です。主催者は、貴社の事業発展に役立つ製品やサービスをご案内するためにこのデータを利用する場合があります。ご自身の権利を行使する場合、または主催者の活動、サービス、イベントに関する提案をご希望されない場合は、主催者にメールをお送りください。詳細：個人情報保護方針。',
      },
      buttons: {
        save: '保存',
        locked: 'ロック済み',
        submit: '保存して送信',
      },
      asterix: {
        '*': '再ログインして、情報を複数回に分けて入力できます',
        '**': '入力が確定しました。内容は変更できなくなります。',
      },
    },
    formInformation: {
      required_answer: '必須回答',
      add_new_question: '新しい質問を追加',
      answer: '回答',
      add_answer: '回答を追加',
      save: '保存',
      saved: '質問を保存しました',
      are_you_sure: 'この質問を削除してもよろしいですか？',
      confirm: '確認',
      cancel: 'キャンセル',
    },
    product: {
      catalog_of_your_product: '製品カタログ',
      no_category_available: '利用可能なカテゴリがありません',
      new_product: '新規製品',
      search: '検索',
      type_of_product: '製品タイプ',
      enter_name_of_the_vitange: '製品名を入力',
      select_vintage_of_the_vitange: 'この製品のヴィンテージを選択',
      technical_sheet: 'PDFファイル、最大5MB',
      edit: '編集',
      create_new_product: '新しい製品を作成',
      change_vintage: '製品を変更',
      product_information: '製品情報',
      producer_name: '生産者名',
      commercial_name_of_the_vintage: '製品の商品名',
      description_of_the_product: '製品説明（フランス語、500文字以内）',
      product_description_in_english: '製品説明（英語、500文字以内）',
      logo_on_label: 'ラベルの共同出展ロゴ',
      pics_of_product: '製品画像',
      cuvee_information: '製品情報',
      product_type: '製品タイプ',
      type_of_wines: 'ワインの種類',
      color: '色',
      region: '地域',
      classification: '格付け',
      type_of_culture: '栽培方法',
      grape_variety: 'ブドウ品種',
      perntage_grape_variety: 'ブドウ品種 %',
      percentage_alcohol: 'アルコール度数 %',
      type_of_harvest: '収穫方法',
      allergen: 'アレルゲン',
      flavors: 'フレーバー',
      format: '容量',
      price_range: '価格帯',
      price_range_ex_celler: '蔵出し価格帯',
      no_file_selected: 'ファイルが選択されていません',
      choose_a_file: 'ファイルを選択',
      tasting_note: 'テイスティングノート',
      edit_technical_sheet: '技術資料を編集',
      type_of_grape: '収穫方法',
      ai_translate: 'AI翻訳',
      description_of_the_product_ja: '製品説明（日本語）',
      ai_translate_ja: '日本語にAI翻訳',
      translating: '翻訳中...',
      type_of_sub_product: 'サブ製品タイプ',
      category: 'カテゴリ',
      bio: 'オーガニック',
      product_composition: '製品構成',
      distributer: '販売元',
    },
  },
};
